
import { Vue, Component, Ref } from 'vue-property-decorator';
import AddVoucherModal from './AddVoucherModal.vue';
import lazyInject from '@/di';
import OrderService, { PaymentChannelEnum } from '@/services/order.service';
import { BASE_URL } from '@/common/constant';
import { $delay } from '@/common/utils';
import { component as Viewer } from 'v-viewer';
import UserService from '@/services/user.service';
import { ISPUImageUploadOptions } from '@/common/interface/spu';
import { DebounceTime } from '@/common/decorator';
import VoucherService from '@/services/voucher.service';
import { FormModel } from 'ant-design-vue';
import moment, { Moment } from 'moment';
import CorrelationOrderDrawer from './CorrelationOrderDrawer.vue';
import { AuthEnum } from '@/services/permission.service';


@Component({
  components: {
    AddVoucherModal,
    Viewer,
    CorrelationOrderDrawer,
  },
})
export default class PaymentDrawer extends Vue {
  visible = false;

  BASE_URL = BASE_URL;

  AuthEnum = AuthEnum;

  labelCol = { span: 6 };

  wrapperCol = { span: 16 };

  isHidden = false;

  uploading = false;

  isVisible = false;

  isLoading = false;

  disabledtype = false;

  buttonText = '提交';

  extra = '';

  fileList: any = [];

  token: any = '';

  selectedRowId: any = '';

  transactionNoCheckStatus: any = '';

  options: ISPUImageUploadOptions = {
    allowDuplicateUploads: false,
    target: `${BASE_URL}/tool/upload`,
    testChunks: false,
    headers: {},
    chunkSize: 5 * 1024 * 1024,
  };

  queryData: any = {};

  @Ref('addVoucherModal')
  addVoucherModal!: AddVoucherModal;


  @lazyInject(OrderService)
  orderService!: OrderService;

  @lazyInject(UserService)
  protected userService!: UserService;

  @lazyInject(VoucherService)
  voucherService!: VoucherService;

  @Ref('correlationOrderDrawer')
  correlationOrderDrawer!: CorrelationOrderDrawer;

  @Ref() readonly ruleForm!: FormModel;

  paymentChannel: Array<{
    id: PaymentChannelEnum;
    name: string;
  }> = [];


  get disabled() {
    if (
      this.form.paymentChannelId &&
      this.form.tradeid &&
      this.fileList.length > 0 &&
      this.form.paymentTime !== null &&
      this.selectedRowId
    ) {
      return false;
    } else if (
      this.form.paymentChannelId &&
      +this.form.paymentChannelId === PaymentChannelEnum.无需付款
    ) {
      return false;
    } else {
      return true;
    }
  }

  paymentVoucherColumns = [
    {
      title: '选择',
      key: 'radio',
      width: 60,
      scopedSlots: { customRender: 'radio' },
    },

    {
      title: '支付凭证图片',
      dataIndex: 'voucher_pic',
      key: 'voucher_pic',
      align: 'center',
      width: 120,

      scopedSlots: { customRender: 'voucher_pic' },
    },
    {
      title: '付款渠道',
      dataIndex: 'channel',
      key: 'channel',
      align: 'center',
      width: 90,
      scopedSlots: { customRender: 'channel' },
    },
    {
      title: '付款流水号',
      dataIndex: 'flow_no',
      key: 'flow_no',
      width: 120,
      align: 'center',
    },
    {
      title: '付款时间',
      dataIndex: 'receive_time',
      key: 'receive_time',
      width: 120,
      align: 'center',
    },
    {
      title: '付款凭证金额',
      dataIndex: 'amount',
      key: 'amount',
      width: 120,
      align: 'center',
    },
    {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      width: 100,
      scopedSlots: { customRender: 'action' },

    },
  ];

  flowNo = '';

  form: {
    paymentChannelId: string | undefined;
    transactionNo: string;
    receiptVoucherImg: string;
    paymentTime: Moment | null;
    tradeid: string;
  } = {
      paymentChannelId: undefined,
      transactionNo: '',
      receiptVoucherImg: '',
      paymentTime: null,
      tradeid: '',
    };

  paymentSelectedRows: any = [];

  order: any = {};

  pagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    onChange: this.onChangePage,
    showSizeChanger: true,
    showTotal: () => {
      return `共${this.pagination.total}条`;
    },
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    onShowSizeChange: this.onShowSizeChange,
  };

  async init(order: any) {
    this.order = order;
    this.visible = true;
    this.form.paymentTime = moment(new Date());
    const res = await this.orderService.paymentChannels();
    if (res) {
      this.paymentChannel = res;
    }
    this.options.headers.AUTHORIZATION = this.userService.currentUser()?.token;
    this.token = this.userService.currentUser()?.token;
  }

  onClose() {
    this.visible = false;
    this.fileList = [];
    this.form = {
      paymentChannelId: undefined,
      transactionNo: '',
      receiptVoucherImg: '',
      paymentTime: null,
      tradeid: '',
    };
    this.selectedRowId = '';
    this.transactionNoCheckStatus = '';
    this.paymentSelectedRows = [];
    this.disabledtype = false;
    this.flowNo = '';
    this.extra = '';
    this.buttonText = '提交';
  }

  lookOrder(record: any) {
    if (record.status !== 0) {
      this.correlationOrderDrawer.init(record);
    } else {
      this.$message.error('该凭证下未关联订单');
    }
  }

  onChangePage(page: any, pageSize: any) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
  }

  onShowSizeChange(current: any, size: any) {
    this.pagination.current = current;
    this.pagination.pageSize = size;
  }

  AddVoucher(type: string) {
    // console.log(type);
    this.addVoucherModal.init(type);
  }

  oChangeChannel(val: PaymentChannelEnum | string) {
    const channelId = this.form.paymentChannelId;

    if (channelId === (val as string)) {
      return;
    }

    if (Number(val) === PaymentChannelEnum.无需付款) {
      this.$set(this.form, 'transactionNo', '');
      this.$set(this.form, 'paymentTime', null);
      this.isHidden = true;
    } else {
      this.isHidden = false;
    }
    this.$set(this.form, 'paymentChannelId', `${val}`);
  }

  onChangePaymentTime(value: Moment) {
    this.$set(this.form, 'paymentTime', value);
  }

  async onChangeImg(info: any) {
    // console.log(info);
    if (info.file.status === 'uploading') {
      this.uploading = true;
    }
    if (info.file.status === 'error') {
      this.uploading = false;
      const { code, error } = info.file.response;
      if (code === 400) {
        this.$message.error(error);
        await $delay(1000);
        this.$router.push({
          path: '/login',
          query: {
            redirect: this.$route.fullPath,
          },
        });
      } else {
        this.$message.error(error);
      }
    }
    if (info.file.status === 'done') {
      const { data } = JSON.parse(info.file.xhr.response);
      const headlineImage = {
        id: data[0]?.id,
        uid: data[0]?.id,
        url: data[0]?.url,
        name: 'mage.png',
        status: 'done',
      };
      this.fileList.push(headlineImage);
      this.$set(this.form, 'headlineImage', headlineImage);
      this.uploading = false;
    }
    if (info.file.status === 'removed') {
      if (info.file.xhr) {
        const { data } = JSON.parse(info.file.xhr.response);
        const id = data[0]?.id;
        this.fileList = this.fileList.filter((res: { id: any }) => { return res.id !== id; });
      } else {
        // console.log(info.file);
        const { id } = info.file;
        this.fileList = this.fileList.filter((res: { id: any }) => { return res.id !== id; });
      }
    }
  }

  delShopImg(index: number) {
    const idList = this.fileList.map((item: any) => item.id);
    idList.splice(index, 1);
    this.fileList.splice(index, 1);
  }


  beforeUpload(file: { type: string; size: number }) {
    this.aginGetToken();
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      this.$message.error('请上传 png/jpeg 格式的照片!');
    }
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      this.$message.error('照片必须小于5MB!');
    }

    return isJpgOrPng && isLt5M;
  }

  aginGetToken() {
    this.options.headers.AUTHORIZATION = this.userService.currentUser()?.token;
    this.token = this.userService.currentUser()?.token;
  }

  @DebounceTime(320)
  async onChange() {
    if (this.extra && this.extra !== '') {
      this.extra = '';
      this.transactionNoCheckStatus = 'toCheck';
      this.buttonText = '提交';
    }
    this.flowNo = this.form.tradeid;
    this.paymentSelectedRows = [];
    this.getDyhOrderVoucherDetail(this.form.tradeid);
  }
  async getDyhOrderVoucherDetail(record: any) {
    if (!record) {
      return;
    }
    const res = await this.voucherService.getDyhOrderVoucherList({
      flow_no: record,
      category: 1,
      show_voucher: 1,
    });
    this.paymentSelectedRows = res.list;
    this.selectedRowId = res.list[0]?.id;
  }
  queryChange(val: any) {
    this.flowNo = val;
    this.paymentSelectedRows = [];
    this.getDyhOrderVoucherDetail(val);
  }


  async preVerifyTansactionNo(orderId: string, tradeid: string) {
    if (this.transactionNoCheckStatus === 'checking') {
      return;
    }
    this.transactionNoCheckStatus = 'checking';
    const res = await this.orderService.BOrderTransactionNoCheck(
      orderId,
      tradeid,
    );

    this.transactionNoCheckStatus = 'checked';

    if (res !== null) {
      this.disabledtype = false;
      this.buttonText = '继续提交';
      this.extra = res;
      return;
    }
    // 流水单号未使用，直接提交
    await this.submit(true);
  }

  submit(retry?: boolean) {
    this.disabledtype = true;
    this.funsubmit(retry);
  }

  @DebounceTime(618)
  async funsubmit(retry?: boolean) {
    // console.log(this.order);
    if (this.order === null) {
      return;
    }
    if (this.order.isPay !== '未支付') {
      this.$message.warn('当前订单支付状态异常，请检查！');
      return;
    }
    if (
      (typeof retry !== 'undefined' && retry === true) ||
      this.transactionNoCheckStatus === 'checked' ||
      (this.form.paymentChannelId &&
        +this.form.paymentChannelId === PaymentChannelEnum.无需付款)
    ) {
      const receiptVoucherImg = this.fileList.map((file: any) => file.id).join(',');
      const params = {
        id: this.order?.orderId,
        paychannel: this.form.paymentChannelId!,
        paymentTime: moment(this.form.paymentTime).format(
          'YYYY-MM-DD HH:mm:ss',
        ),
        tradeid: `${this.form.tradeid}`,
        receiptVoucherImg,
        voucherId: this.selectedRowId,
      };
      // console.log(params);
      try {
        const res = await this.orderService.payStatus(params);
        // console.log(res);
        if (res) {
          this.$message.success('成功');
          this.$emit('refresh');
          setTimeout(() => {
            this.onClose();
          }, 500);
        } else {
          this.disabledtype = false;
          this.transactionNoCheckStatus = 'toCheck';
          this.buttonText = '提交';
        }
      } catch (error) {
        this.disabledtype = false;
      }
      return;
    }

    this.ruleForm.validate(async (valid) => {
      if (valid && this.paymentValidatort()) {
        if (this.isLoading) {
          return;
        }
        this.isLoading = true;
        try {
          await this.preVerifyTansactionNo(
            `${this.order?.orderId}`,
            this.form.tradeid,
          );
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
        }
      } else {
        this.disabledtype = false;
      }
    });
  }

  paymentValidatort() {
    if (!this.form.paymentChannelId) {
      this.$message.warn('请选择支付渠道！');
      return false;
    }

    if (+this.form.paymentChannelId === PaymentChannelEnum.无需付款) {
      this.$set(this.form, 'tradeid', '');
      this.$set(this.form, 'paymentTime', null);
      return true;
    }

    if (
      !this.form.tradeid ||
      this.form.tradeid.replace(/\s*/g, '') === ''
    ) {
      this.$message.warn('请填写支付流水单号！');
      return false;
    }

    if (!this.form.paymentTime) {
      this.$message.warn('收款时间不能为空。');
      return false;
    }
    const selectedTime = new Date(this.form.paymentTime as any);
    const now = new Date();
    if (selectedTime > now) {
      this.$message.warn('收款时间不能大于当前时间。');
      return false;
    }

    return true;
  }

  onRadioChange(e: any) {
    this.selectedRowId = e.id;
  }

  activated() {
    this.$message.success('加载中...');
  }
}

